import { Datoblock } from "./Types";

export interface RoadsideScreeningQuestionQueryResponse {
    roadside?: {
        screenerIntroText: Datoblock;
        screenerAlertBoxWarn: Datoblock;
    };
}

export const RoadsideScreeningQuestionQuery = `{
  roadside {
    screenerIntroText {
      blocks
      links
      value
    }
    screenerAlertBoxWarn {
      blocks
      links
      value
    }
  }
}`;
